/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import Loading from '../../components/Loading';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import LogoDark from '../../images/logo/gitme-logo-white.svg';
import { validateEmail } from '../../utils';
import UserAgreementModal from '../../components/Payment/UserAgreementModal';

const GetStartedEnterprise = () => {
  const location = useLocation();

  const [userInfo, setUserInfo] = useState(null);
  const [email, setEmail] = useState();
  const [fullName, setFullName] = useState();
  const [webSite, setWebSite] = useState();
  const [companyName, setCompanyName] = useState();
  const [loading, setLoading] = useState();
  const [showSuccess, setShowSuccess] = useState(false);
  const [appId, setAppId] = useState('');
  const [clientId, setClientId] = useState('');
  const [clientSecret, setClientSecret] = useState('');
  const [privateKey, setPrivateKey] = useState('');

  const [hasAcceptedAgreement, setHasAcceptedAgreement] = useState(false);
  const [openAcceptedAgreement, setOpenAcceptedAgreement] = useState(false);

  const fetchWithToken = async ({
    url,
    method = 'GET',
    data = null,
    onSuccess,
    onError
  }) => {
    const token = new URLSearchParams(location.search).get('token');
    if (!token) return;

    try {
      const res = await axios({
        url,
        method,
        data,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      onSuccess?.(res.data);
    } catch (err) {
      console.error('Request failed:', err);
      onError?.(err);
    }
  };

  useEffect(() => {
    fetchWithToken({
      url: `${process.env.REACT_APP_BACKEND_URL}/github/enterprise/get-data`,
      onSuccess: data => setUserInfo(data?.data),
      onError: err =>
        toast.error(err?.response?.data?.message || 'Not found user')
    });
  }, [location]);

  const handleStart = async () => {
    setLoading(true);

    fetchWithToken({
      url: `${process.env.REACT_APP_BACKEND_URL}/github/enterprise/lead-register`,
      method: 'POST',
      data: {
        companyName,
        fullName,
        email,
        appId,
        clientId,
        clientSecret,
        privateKey
      },
      onSuccess: () => {
        setLoading(false);
        setShowSuccess(true);
      },
      onError: err => {
        setLoading(false);
        console.error('Failed to analyze repos', err);
        toast.error('Error: ' + err?.response?.data?.message);
      }
    });
  };

  const handleStarted = async () => {
    if (!hasAcceptedAgreement) {
      toast.error('Please accept the agreement to proceed.');
      return;
    }

    if (!companyName) {
      toast.error('Please select a company name to proceed.');
      return;
    }

    if (!fullName) {
      toast.error('Please enter your full name.');
      return;
    }

    if (!webSite) {
      toast.error('Please enter your website.');
      return;
    }

    if (!appId) {
      toast.error('Please enter your App ID.');
      return;
    }

    if (!clientId) {
      toast.error('Please enter your Client ID.');
      return;
    }

    if (!clientSecret) {
      toast.error('Please enter your Client Secret.');
      return;
    }

    if (!privateKey) {
      toast.error('Please enter your Private Key.');
      return;
    }

    if (!validateEmail(email)) {
      toast.error('Please enter a valid email address.');
      return;
    }

    handleStart();
  };

  if (!userInfo) {
    return null;
  }

  return (
    <div className="min-h-screen flex bg-gray-100">
      {/* Left Side - Form */}
      <div className="w-full md:w-1/2 flex items-center justify-center p-10 bg-white">
        {showSuccess ? (
          <div className=" left-6 z-50 rounded-xl  px-6 py-4 text-blue-800  w-full">
            <div className="flex items-start space-x-3">
              <div className="text-2xl">✅</div>
              <div className="flex flex-col gap-5">
                <span className="font-semibold text-2xl">
                  Successfully submitted!
                </span>
                <span className="text-xl mt-1">
                  Your contact information has been received. We’ll be in touch
                  with you shortly.
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div className="max-w-md w-full">
            <h2 className="text-3xl font-bold mb-4 text-black">
              Let{"'"}s gets started for Github Enterprise
            </h2>
            {/* Company Name */}
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">
                Company Name
              </label>
              <input
                type="text"
                value={companyName}
                onChange={e => setCompanyName(e.target.value)}
                placeholder="Enter your company"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-600 focus:outline-none"
              />
            </div>
            {/* Full Name */}
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">
                Full Name
              </label>
              <input
                type="text"
                value={fullName}
                onChange={e => setFullName(e.target.value)}
                placeholder="Enter your fullname"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-600 focus:outline-none"
              />
            </div>
            {/* Website Name */}
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Website</label>
              <input
                type="text"
                value={webSite}
                onChange={e => setWebSite(e.target.value)}
                placeholder="Enter your fullname"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-600 focus:outline-none"
              />
            </div>

            {/* Email */}
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Email</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-600 focus:outline-none"
              />
            </div>

            {/* App ID */}
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">
                GitHub App ID
              </label>
              <input
                type="text"
                value={appId}
                onChange={e => setAppId(e.target.value)}
                placeholder="Enter your GitHub App ID"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-600 focus:outline-none"
              />
            </div>

            {/* Client ID */}
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">
                Client ID
              </label>
              <input
                type="text"
                value={clientId}
                onChange={e => setClientId(e.target.value)}
                placeholder="Enter your Client ID"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-600 focus:outline-none"
              />
            </div>

            {/* Client Secret */}
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">
                Client Secret
              </label>
              <input
                type="password"
                value={clientSecret}
                onChange={e => setClientSecret(e.target.value)}
                placeholder="Enter your Client Secret"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-blue-600 focus:outline-none"
              />
            </div>

            {/* Private Key (PEM content) */}
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">
                Private Key (PEM file content)
              </label>
              <textarea
                rows="6"
                value={privateKey}
                onChange={e => setPrivateKey(e.target.value)}
                placeholder="Paste your private key content here"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm font-mono focus:ring-2 focus:ring-blue-600 focus:outline-none"
              />
            </div>
            {/* Agreement */}
            <div className="pt-4">
              <label className="flex items-start text-sm text-gray-700">
                <input
                  type="checkbox"
                  className="mt-1 mr-2 accent-yellow-500"
                  onChange={e => {
                    setHasAcceptedAgreement(e.target.checked);
                    setOpenAcceptedAgreement(e.target.checked);
                  }}
                  checked={hasAcceptedAgreement}
                />
                <span>I have read and accept the agreement.</span>
              </label>
            </div>
            <UserAgreementModal
              isOpen={openAcceptedAgreement}
              onClose={() => {
                setOpenAcceptedAgreement(false);
              }}
            />
            {/* Button */}
            <button
              className="mt-6 w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition"
              onClick={handleStarted}
              disabled={loading}
            >
              {loading ? <Loading type="inline" /> : 'Get Started'}
            </button>
          </div>
        )}
      </div>

      {/* Right Side - Logo Only */}
      <div className="hidden md:flex w-1/2 bg-blue-600 items-center justify-center p-10 rounded-l-[2rem] flex-col text-center text-white">
        <img
          className="dark:block mb-6"
          src={LogoDark}
          alt="Logo"
          style={{ width: '10rem' }}
        />
        <p className="text-lg font-semibold mb-2 max-w-md">
          A New Standard in Developer Performance Analytics.
        </p>
        <p className="text-sm font-light max-w-md leading-relaxed">
          Gitme leverages advanced AI to deliver accurate, unified, and
          transparent insights — replacing fragmented metrics with a single
          source of truth.
        </p>
      </div>
    </div>
  );
};

export default GetStartedEnterprise;
